import { useConfig } from '../../ConfigContext';
import SocialsHeader from './SocialsHeader';
import MusicControls from './MusicControls';
import SocialsStats from './SocialsStats';
import React from 'react';
import ClassicControls from './ClassicControls';
import CropperComponent from './CropperComponent';
import MultipleImagesComponent from './MultipleImagesComponent';
import { cropSlides, designSlides } from '../Carousel/carouselData';
import PairControls from './PairControls';
import { glassTypes } from '../../../glassConsts';

export default function Overlay({ localSize, thisRef }) {
  const { general, setGeneralState, size } = useConfig();

  const onCropComplete = (handler) => (croppedArea, croppedAreaPixels) => {
    handler(croppedAreaPixels);
  };
  const pluginUrl = window.GBCONF ? window.GBCONF.pluginUrl : '';
  let widthCoefficient = 0.62;
  let heightCoefficient = 0.47;
  let heightPaddingCoefficient = 0.02;

  let textBottomCoefficient = 0.27;
  let paddingTopCoefficient = 0.15;

  const isWeddingDesign = () =>
    designSlides[general.selectedCarouselNameDesignIndex].cssClass ===
      'weddingBackground' && general.glassType === 'pair';

  if (general.glassType === 'pair') textBottomCoefficient = 0.28;

  if (isWeddingDesign()) {
    heightPaddingCoefficient = 0.035;
    textBottomCoefficient = 0.21;
  }

  if (general.glassType === 'pair' || general.glassType === 'classic') {
    if (
      cropSlides[general.selectedCarouselCropIndex].cssClass === 'thinner-mask'
    ) {
      widthCoefficient = 0.5;
    }

    if (
      cropSlides[general.selectedCarouselCropIndex].cssClass === 'flatter-mask'
    ) {
      heightCoefficient = 0.4;
      heightPaddingCoefficient = 0.09;
      if (isWeddingDesign()) heightPaddingCoefficient = 0.105;
    }

    if (
      cropSlides[general.selectedCarouselCropIndex].cssClass === 'heart-mask' &&
      isWeddingDesign()
    ) {
      heightCoefficient = 0.475;
      heightPaddingCoefficient = 0.03;
    }
  }

  if (general.glassType === 'music') {
    widthCoefficient = 0.5;
    heightCoefficient = 0.38;
    paddingTopCoefficient = 0.15;
  }

  if (general.glassType === 'socials') {
    widthCoefficient = 0.5;
    heightCoefficient = 0.38;
  }

  if (general.glassType === 'multiple') {
    widthCoefficient = 0.67;
    heightCoefficient = 0.69;
    paddingTopCoefficient = 0.13;
  }

  return (
    <div
      style={{
        position: 'absolute',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        top: 0,
        margin: 'auto',
        paddingTop: size.height * paddingTopCoefficient,
        paddingRight: size.width * 0.015,
        height: size.height,
        width: size.width,
      }}
    >
      {general.glassType === 'socials' && (
        <SocialsHeader width={size.width * widthCoefficient} />
      )}

      {(general.glassType === 'socials' ||
        general.glassType === 'music' ||
        general.glassType === 'pair' ||
        general.glassType === 'classic') && (
        <div
          className={
            general.glassType === 'pair' || general.glassType === 'classic'
              ? cropSlides[general.selectedCarouselCropIndex].cssClass
              : ''
          }
          style={{
            width:
              cropSlides[general.selectedCarouselCropIndex].cssClass !==
              'circle-mask'
                ? size.width * widthCoefficient
                : size.height * heightCoefficient,
            height: size.height * heightCoefficient,
            marginBottom: size.height * heightPaddingCoefficient,
            background: general.imageSrc ? 'transparent' : '#fff',
            zIndex: 1,
            pointerEvents: 'auto',
          }}
        >
          <div
            ref={thisRef}
            className="crop-container"
            style={{
              position: 'relative',
              width: '100%',
              height: '100%',
              overflow: 'hidden',
            }}
          >
            <CropperComponent
              isRounded={
                cropSlides[general.selectedCarouselCropIndex].cssClass ===
                  'circle-mask' &&
                (general.glassType === 'classic' ||
                  general.glassType === 'pair')
              }
              itemObject={general}
              overlayWidth={localSize.width}
              overlayHeight={localSize.height}
              onCropCompleteFunction={onCropComplete((px) =>
                setGeneralState({ croppedAreaPixels: px })
              )}
              onCropChangeFunction={(c) => setGeneralState({ crop: c })}
              onZoomChangeFunction={(z) => {
                console.log('aaaaaaa', z);
                setGeneralState({ zoom: z });
              }}
            />
          </div>

          {general.glassType === 'music' && (
            <MusicControls
              color={general.color}
              font={general.font}
              size={general.size}
              title={general.musicName}
              subtitle={general.musicInterpret}
            />
          )}

          {general.glassType === 'socials' && (
            <SocialsStats
              color={general.color}
              font={general.font}
              style={{
                marginTop: 35,
              }}
            />
          )}
        </div>
      )}

      {/* Textové vrstvy */}
      {general.glassType === 'pair' && !general.orientationHorizontal && (
        <>
          <div
            style={{
              position: 'absolute',
              bottom: size.height * textBottomCoefficient,
              width: size.width * widthCoefficient,
              zIndex: '10',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
            }}
          >
            {designSlides[general.selectedCarouselNameDesignIndex].cssClass ===
              'weddingBackground' && (
              <img
                style={{
                  margin: 'auto',
                }}
                width={size.width / 7}
                src={pluginUrl + 'weddingRings.png'}
                color="white"
                alt="weddinDesignImg"
              />
            )}
            {designSlides[general.selectedCarouselNameDesignIndex].cssClass ===
              'heartBackground' && (
              <img
                style={{
                  marginLeft: 'auto',
                  marginRight: 'auto',
                  marginBottom: -size.height / 14,
                }}
                width={size.width / 7}
                src={pluginUrl + 'heartDesign.png'}
                color="white"
                alt="weddinDesignImg"
              />
            )}
            {designSlides[general.selectedCarouselNameDesignIndex].cssClass ===
              'ampBackground' && (
              <div
                style={{
                  marginLeft: 'auto',
                  marginRight: 'auto',
                  marginBottom: -size.height / 11,
                  fontSize: size.width / 7,
                  fontFamily: 'Roboto',
                  fontWeight: 'bold',
                  color: '#b7b7b7',
                }}
              >
                &
              </div>
            )}
            {general.glassType === 'pair' && <PairControls />}
          </div>
        </>
      )}

      {general.glassType === 'classic' && !general.orientationHorizontal && (
        <ClassicControls />
      )}

      {general.glassType === 'multiple' && (
        <div
          style={{
            width: size.width * widthCoefficient,
            height: size.height * heightCoefficient,
            zIndex: 1,
            pointerEvents: 'auto',
          }}
        >
          <MultipleImagesComponent />
        </div>
      )}
    </div>
  );
}
